export const ONBOARDING_TOTAL_STEPS = 7

export const LANGUAGE_OPTIONS = ['Español', 'Valencià', 'Català', 'English', 'Français', 'Português']

export const ONBOARDING_DRAFT_KEY = 'juntas_onboarding_step1_draft'
export const ONBOARDING_LAST_STEP_KEY = 'juntas_onboarding_last_step'

export const TRANS_CONSENT_VERSION = 'trans_consent_v1_2026-05-15'
export const TRANS_PREF_CONSENT_VERSION = 'pref_v1_2026-05-15'

export const WORK_SCHEDULE_OPTIONS = [
  { value: 'mornings', label: 'Mañanas' },
  { value: 'afternoons', label: 'Tardes' },
  { value: 'daytime', label: 'Mañana y tarde' },
  { value: 'nights', label: 'Noches' },
  { value: 'variable', label: 'Variable' },
]

export const REMOTE_WORK_OPTIONS = [
  { value: 'never', label: 'Nunca' },
  { value: 'sometimes', label: 'A veces' },
  { value: 'almost_always', label: 'Casi siempre' },
  { value: 'always', label: 'Siempre' },
]

export const SMOKER_OPTIONS = [
  { value: 'no', label: '🚭 No fumo' },
  { value: 'occasional', label: '🚬 Ocasional' },
  { value: 'yes', label: '🚬 Fumo' },
]

export const DIET_OPTIONS = [
  { value: 'omnivora', label: 'Omnívora' },
  { value: 'flexitariana', label: 'Flexitariana' },
  { value: 'vegetariana', label: 'Vegetariana' },
  { value: 'vegana', label: 'Vegana' },
]

export const COHABITATION_OPTIONS = [
  { value: 'pair', label: 'Pareja de coloc (2)' },
  { value: 'trio_plus', label: 'Trío o grupo (3+)' },
]

export const TRANS_PREFERENCE_OPTIONS = [
  { value: 'yes', label: 'Sí' },
  { value: 'no', label: 'No' },
  { value: 'no_expressed', label: 'Prefiero no decir' },
]

export const GENDER_IDENTITY_OPTIONS = [
  { value: 'cis_woman', label: 'Mujer cis' },
  { value: 'trans_woman', label: 'Mujer trans' },
  { value: 'nonbinary_woman', label: 'Mujer no binaria' },
]

export const KYC_VIA_OPTIONS = [
  {
    value: 'A_dni',
    label: 'Vía A · DNI o pasaporte',
    hint: 'Foto del documento + selfie. Revisión en 24–48 h.',
  },
  {
    value: 'B_carta_asociacion',
    label: 'Vía B · Carta de asociación LGBTQ+',
    hint: 'Si una asociación aliada respalda tu identidad.',
  },
  {
    value: 'C_videollamada',
    label: 'Vía C · Videollamada de 15 min',
    hint: 'Conversación humana con nuestro equipo. Sin evaluar tu cuerpo.',
  },
]

// Recorrido del onboarding — usado por la pantalla de bienvenida de la
// cohorte alpha para dar a la usuaria un mapa de lo que viene.
export const ONBOARDING_STEPS = [
  { n: 1, label: 'Sobre ti', desc: 'Tu nombre, edad e idiomas.' },
  { n: 2, label: 'Familia', desc: '¿Convives con hijas o hijos?' },
  { n: 3, label: 'Horarios', desc: 'Tu ritmo: trabajo, sueño, teletrabajo.' },
  { n: 4, label: 'Estilo de vida', desc: 'Orden, ruido, visitas, animales.' },
  { n: 5, label: 'Preferencias', desc: 'Zonas, presupuesto y con quién convivir.' },
  { n: 6, label: 'Verificación', desc: 'Acreditamos tu identidad. Solo mujeres.' },
  { n: 7, label: 'Carta de Convivencia', desc: 'El pacto de respeto de JUNTAS.' },
]

export const TRANS_CONSENT_TEXT =
  'Declaro voluntariamente mi condición de mujer trans para la personalización interna de mi experiencia en JUNTAS. Esta información no se muestra en feeds ni listas públicas. Puedo retractarla en cualquier momento desde mi perfil.'
